import React from "react";
import Posts from "../Components/Posts.js";
import { ReactSession } from 'react-client-session';

import Header from "../Components/Header.jsx";

const Gallery = () => {
  return (
    <div className="h-screen bg-slate-800">
      <Header wantsToPost={true}/>
      <Posts currentUserId={ReactSession.get("userId")}/>
    </div>
  );
};

export default Gallery;
